var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27892",
    "data-name": "Group 27892",
    transform: "translate(-44 -264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-check",
    "data-name": "Icon feather-check",
    d: "M14,9,8.5,14.5,6,12",
    transform: "translate(44.5 262.487)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28086",
    "data-name": "Group 28086",
    transform: "translate(0 0.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-check-2",
    "data-name": "Icon feather-check",
    d: "M14,9,8.5,14.5,6,12",
    transform: "translate(44.5 262.487)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28085",
    "data-name": "Group 28085",
    transform: "translate(0.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28084",
    "data-name": "Group 28084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37922",
    "data-name": "Path 37922",
    d: "M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z",
    transform: "translate(43.922 263.499)",
    fill: "#ffc31f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37725",
    "data-name": "Path 37725",
    d: "M-1103.126,508.43l-3.358-3.347,1-1,2.356,2.348,6.294-6.348,1,.994Z",
    transform: "translate(1155.406 -230.584)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.9b214115982db2d9107c346bf116d827.svg";
export { ForwardRef as ReactComponent };